import {useSelector} from "react-redux";
import {RootState} from "../../../../../../../redux/store";
import {Button, Upload} from "antd";
import {API_BASE_URL_V2} from "../../../../../../../services/config";
import {CloudUploadOutlined} from "@ant-design/icons";
import {ProfileFormValues} from "../../../schema-validation";
import {useFormContext} from "react-hook-form";
import type {UploadFile} from "antd/es/upload/interface";
import type {UploadChangeParam} from "antd/es/upload";

type ProfileAvatarUploadProps = {
  onImageChange: ((info: UploadChangeParam<UploadFile<any>>) => void) | undefined;
};

export function ProfileAvatarUpload({onImageChange}: ProfileAvatarUploadProps) {
  const {userInfo} = useSelector((state: RootState) => state.userLogin);
  const {watch} = useFormContext<ProfileFormValues>();
  const username = watch("username").toLowerCase();
  return (
    <div>
      <p className="username-text">
        {username && username.length > 0 && `Coachli.co/${username}`}{" "}
      </p>

      <Upload
        name="avatar"
        showUploadList={false}
        headers={{
          authorization: `Bearer ${userInfo?.accessToken}`,
        }}
        action={`${API_BASE_URL_V2}profile/avatar`}
        onChange={onImageChange}
      >
        <Button
          style={{paddingLeft: 0}}
          type="link"
          size="small"
          icon={<CloudUploadOutlined />}
        >
          Upload profile photo
        </Button>
      </Upload>
    </div>
  );
}
